// extracted by mini-css-extract-plugin
module.exports = {"fact":"fact_fact__xgCbH","traitedFact":"fact_traitedFact__3h2KL fact_fact__xgCbH","description":"fact_description__3kKTY"};